import React, { useState, useRef } from 'react';
import Button from '../Button/Button';
import styles from './HiddenList.module.scss';

const HiddenList = ({ items }) => {
  const [isShowAll, setIsShowAll] = useState(false);
  const [listButtonText, setListButtonText] = useState(true);
  const listBlock = useRef(null);
  const innerBlock = useRef(null);
  const textIsButton = listButtonText ? 'See All' : 'Hide All';

  const renderItem = (item, key) => {
    return (
      <div
        className={styles.item}
        key={key}
        itemScope
        itemType='http://schema.org/ListItem'
      >
        {item?.text}
      </div>
    );
  };
  const toggleList = () => {
    listBlock.current.style.setProperty(
      '--height',
      `${innerBlock.current.offsetHeight}px`,
    );
    setIsShowAll(!isShowAll);
    setListButtonText(!listButtonText);
  };

  return (
    <div
      className={`${styles.wrap} ${isShowAll ? styles.open : ''}`}
      ref={listBlock}
      itemScope
      itemType='http://schema.org/ItemList'
    >
      <div className={styles.inner}>
        <div className={styles.list} ref={innerBlock}>
          {items?.points?.map((item, key) => renderItem(item, key))}
        </div>
      </div>

      <div className={styles.showAll} onClick={toggleList}>
        <Button className={styles.button}>{textIsButton}</Button>
      </div>
    </div>
  );
};

export default HiddenList;
